import { useCallback } from 'react';
import type { GoodsCoreModel, IScreensLogging } from '../../../../../api/types';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';
import { useAtomicScreen } from '../../../context/AtomicScreenContext';

type LogOnGoodsPressItemParams = {
  logging: IScreensLogging;
  item: GoodsCoreModel;
};

export const useLogOnGoodsPressItem = () => {
  const screen = useAtomicScreen();

  return useCallback(
    ({ logging, item }: LogOnGoodsPressItemParams) => {
      bridge.logAnalyticsEvent({
        channel: ['firebase', 'amplitude', 'ablylog', 'facebook'],
        name: 'CLICK_GOODS',
        analytics: {
          ...logging.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: logging.ably_only_log,
      });
      if (isNotNil(item.ad)) {
        bridge.logAdEvent({ action: AdAction.CLICK, ad: item.ad });
      }
    },
    [screen],
  );
};
